import { ChatTurnResult } from "../type/chat";
import { RagStreamEvent } from "../type/rag-stream-event";
import {
  errorMessageFromRunError,
  turnResultFromRequiresAction,
  turnResultFromRunCompleted,
} from "./rag-stream";

export class RagRunFailedError extends Error {
  readonly code: string;

  constructor(message: string, code = "") {
    super(message);
    this.name = "RagRunFailedError";
    this.code = code;
  }
}

/** Apply a terminal RAG SSE event to the in-flight turn result holder. */
export function applyRagStreamTerminalEvent(
  event: RagStreamEvent,
  terminal: { current: ChatTurnResult | null },
): void {
  switch (event.type) {
    case "run.completed":
      terminal.current = turnResultFromRunCompleted(event);
      break;
    case "run.requires_action":
      terminal.current = turnResultFromRequiresAction(event);
      break;
    case "run.error":
      throw new RagRunFailedError(errorMessageFromRunError(event), event.code);
    default:
      break;
  }
}

export function requireRagStreamTerminal(terminal: { current: ChatTurnResult | null }): ChatTurnResult {
  if (!terminal.current) {
    throw new Error("RAG stream ended without a terminal event");
  }
  return terminal.current;
}
